import * as angular from 'angular';
import RecordVideoModalBridge from './RecordVideoModalBridge';

angular
  .module('flowingly.runner.library')
  .component('recordVideoModal', RecordVideoModalBridge);
